import React from 'react'
import { Table, Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'

import { addCommas } from 'utils'

const ListCustomerVatBillByPaymentTable = (props) => {
  const { list, onClickRow } = props
  const onPrint = (record) => {
    window.open(
      `/vat/customer-invoice/print?bill_no=${record.bill_no}&customer_invoice_no=${record.customer_invoice_no}&customer_code=${record.customer_code}`,
      '_blank'
    )
  }

  const tableColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '40px',
      fixed: 'left',
      render: (_, record) => {
        return (
          <Button
            type="primary"
            size="small"
            icon={<PrinterOutlined />}
            onClick={(_) => onPrint(record)}
            disabled={record.payment_status !== 'ชำระเงินแล้ว'}
          />
        )
      },
    },
    {
      title: 'เลขที่บิล',
      dataIndex: 'bill_no',
      key: 'bill_no',
      width: '110px',
      fixed: 'left',
      sorter: (a, b) => ('' + a.bill_no).localeCompare(b.bill_no),
      sortDirections: ['ascend', 'descend'],
      render: (_, record) => {
        if (record.customer_invoice_no === '') {
          return (
            <div
              onClick={() => onClickRow(record)}
              style={{
                cursor: 'pointer',
                color: '#0000ff',
              }}
            >
              {record.bill_no}
            </div>
          )
        } else {
          return <div>{record.bill_no}</div>
        }
      },
    },
    {
      title: 'เลขที่ใบวางบิล',
      dataIndex: 'customer_invoice_no',
      key: 'customer_invoice_no',
      width: '110px',
      fixed: 'left',
      sorter: (a, b) =>
        ('' + a.customer_invoice_no).localeCompare(b.customer_invoice_no),
      sortDirections: ['ascend', 'descend'],
      render: (_, record) => {
        if (record.customer_invoice_no !== '') {
          return (
            <div
              onClick={() => onClickRow(record)}
              style={{
                cursor: 'pointer',
                color: '#0000ff',
              }}
            >
              {record.customer_invoice_no}
            </div>
          )
        } else {
          return <div>{record.customer_invoice_no}</div>
        }
      },
    },
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      width: '80px',
      fixed: 'left',
      sorter: (a, b) => ('' + a.date).localeCompare(b.date),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'รหัสลูกค้า',
      dataIndex: 'customer_code',
      key: 'customer_code',
      width: '80px',
      sorter: (a, b) => ('' + a.customer_code).localeCompare(b.customer_code),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: '140px',
      sorter: (a, b) => ('' + a.customer_name).localeCompare(b.customer_name),
      sortDirections: ['ascend', 'descend'],
      render: (text) => <div className="break-word">{text}</div>,
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'actually_paid_total',
      key: 'actually_paid_total',
      width: '90px',
      className: 'text-align-right',
      render: (text) => (
        <div className="text-align-right pr-2"><strong>{addCommas(text)}</strong></div>
      ),
    },
    {
      title: 'ยอดบิล',
      dataIndex: 'individual_bill_total',
      key: 'individual_bill_total',
      width: '90px',
      className: 'text-align-right',
      render: (text) => (
        <div className="text-align-right pr-2">{addCommas(text)}</div>
      ),
    },
    {
      title: 'สถานะ',
      dataIndex: 'payment_status',
      key: 'payment_status',
      width: '90px',
      defaultSortOrder: 'descend',
      sorter: (a, b) => ('' + a.payment_status).localeCompare(b.payment_status),
      sortDirections: ['ascend', 'descend'],
    },
  ]

  return (
    <div>
      <Table
        rowKey={(record) => `id+${record.product_code}`}
        dataSource={list}
        columns={tableColumns}
        pagination={false}
        scroll={{ x: 1000, y: 580 }}
        size="small"
        style={{
          maxWidth: '1200px',
          minHeight: '600px',
          backgroundColor: '#FFFFFF',
        }}
      />
    </div>
  )
}

export default ListCustomerVatBillByPaymentTable
